export const getLogo = (logo) => {

    if (logo) {
        return logo
    } else {
        return require('../images/default_startup_logo.svg')
    }
}

export const getEcoLogo = (logo) => {

    if (logo) {
        return logo
    } else {
        return require('../images/icon-ecosystem-light-blue.svg')
    }
}

export default {
    getLogo,
}
